import actions from './actions'

const initialState = {
  data: null,
  loading: false,
  external_location_id: null,
  is_import_clover_available: false,
}

export default function integrationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
